var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',_vm._g(_vm._b({attrs:{"type":"daterange","value-format":"yyyy-MM-dd","clearable":false,"range-separator":_vm.$t('datePicker.to'),"start-placeholder":_vm.$t('datePicker.startPlaceholder'),"end-placeholder":_vm.$t('datePicker.endPlaceholder'),"picker-options":_vm.pickerOptions}},'el-date-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }